<script setup lang="ts">
  import { Tooltip } from '@/shared/ui';
  import type { MemberOverflowDisplay } from '../../lib/member-overflow-display';

  defineProps<{
    display: MemberOverflowDisplay;
  }>();
</script>

<template>
  <span class="inline-flex items-center gap-1.5 flex-nowrap text-sm text-gray-07">
    <span class="min-w-0 shrink">{{ display.primary }}</span>
    <Tooltip
      v-if="display.extraCount > 0"
      :content="display.tooltipText"
      theme="membersOverflow"
      placement="top"
    >
      <span
        class="inline-flex h-6 min-w-6 shrink-0 cursor-default items-center justify-center rounded-full bg-gray-08 px-1 text-[11px] font-medium leading-none text-gray-07 tabular-nums"
        :aria-label="`Mais ${display.extraCount} itens`"
      >
        +{{ display.extraCount }}
      </span>
    </Tooltip>
  </span>
</template>
